import { ActionButton, actionButtonStyles } from "./ActionButton";

interface EditButtonProps {
  onEdit: () => void;
  canEdit?: boolean;
}

export function EditButton({ onEdit, canEdit = true }: EditButtonProps) {
  if (!canEdit) return null;

  return (
    <ActionButton
      icon="pencil"
      onPress={onEdit}
      tooltip="Edit"
      style={actionButtonStyles.iconBtn}
      tooltipOffsetX={-4}
    />
  );
}
